<template>
  <div style="min-height: 100%">
    <div class="text-center piv">
      <label
        class="titrePage"
        style="font-size: 40px"
      >
        {{ $t("Panier.TitrePage") }}
      </label>
    </div>
    <v-img
      style="height: 100%; padding-top: 50px; padding-bottom: 50px"
      class="imageFond"
    >
      <div>
        <v-col cols="12">
          <v-row>
            <v-col
              cols="12"
              md="8"
              order="2"
              order-md="1"
            >
              <v-card
                class="rounded-0 pa-7"
                elevation="0"
                style="width: 100%; height: 100%"
              >
                <v-form
                  ref="form"
                  v-model="formValid"
                >
                  <v-row class="mt-0">
                    <v-col
                      cols="12"
                      class=""
                    >
                      <label style="font-weight: bold">{{
                        $t(
                          "Panier.SectionIdentificationEleve.TitreSectionIdentification"
                        )
                      }}</label>
                    </v-col>
                    <v-col
                      cols="12"
                      class="py-0 pr-1"
                    >
                      <v-radio-group
                        class=""
                        v-model="radioGroup"
                        v-on:change="ChangementOrganismeSelectionnee()"
                        row
                      >
                        <v-radio
                          :label="$t('dialogInscription.radioButtonCssMonteregieEstrie', { nomRegion: appStore.nomRegion })"
                          :value="CSSMonteregieEstrie"
                        ></v-radio>
                        <v-radio
                          :label="$t('dialogInscription.radioButtonCssAutreQueMonteregieEstrie', { nomRegion: appStore.nomRegion })"
                          :value="AutreCSS"
                        ></v-radio>
                        <v-radio
                          :label="$t('dialogInscription.radioButtonEtablissementPrive')"
                          :value="EtablissementPrive"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>

                    <!-- Checkbox scolarisé à la maison -->
                    <v-col
                      cols="12"
                      class="py-1 pr-1"
                    >
                      <v-checkbox
                        :label="$t('dialogInscription.checkboxScolarisation')"
                        v-if="!(
                            estCSSExterne ||
                            estEtablissementPrive
                          ) && estValideChoixProvenance"
                        v-model="enfantScolariseMaison"
                        :disabled="true"
                      ></v-checkbox>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="4"
                      class="py-1 pr-1"
                    >
                      <v-autocomplete
                        :items="inscriptionStore.listeCssMinimise"
                        v-if="!(estCSSExterne ||
                        estEtablissementPrive) && estValideChoixProvenance"
                        v-model="organismeFrequenteSelect"
                        v-on:change="ChangementOrganismeSelectionnee()"
                        item-text="nom"
                        item-value="cssId"
                        return-object
                        dense
                        :label="$t('Panier.SectionIdentificationEleve.OrganismeFrequente')"
                        outlined
                        hide-details="auto"
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      v-if="
                        !estCSSExterne &&
                        !estEtablissementPrive && estValideChoixProvenance
                      "
                      cols="12"
                      sm="5"
                      class="py-1 pr-1"
                    >
                      <v-text-field
                        :label="$t('Panier.SectionIdentificationEleve.AdresseCourriel')"
                        :rules="[...rules.courriel, ...rules.texte]"
                        v-model="informationElevePanierVM.adresseCourrielCommunication"
                        outlined
                        hide-details="auto"
                        dense
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="3"
                      class="py-1 pr-1"
                    >
                      <!-- Menu calendrier pour sélectionner la date de naissance -->
                      <v-menu
                        id="idMenuCalendrier"
                        ref="menu2"
                        v-if="
                          !(
                            estCSSExterne ||
                            estEtablissementPrive
                          ) && estValideChoixProvenance
                        "
                        v-model="menuDateNaissanceCssConnu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="dateNaissanceCssConnu"
                            :rules="[...rules.texte, ...rules.dateNaissance]"
                            :label="
                              $t(
                                'Panier.SectionIdentificationEleve.DateNaissance'
                              )
                            "
                            v-mask="'####-##-##'"
                            persistent-hint
                            outlined
                            hide-details="auto"
                            dense
                            prepend-icon="mdi-calendar"
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="dateParDefaultCssConnu"
                          v-on:change="
                            ChangerDateNaissance(
                              typeDateNaissance.eleveMembre,
                              dateParDefaultCssConnu
                            )
                          "
                          :min="dateNaissanceMin"
                          :max="dateNaissanceMax"
                          :disabled-date="(date) => date >= new Date()"
                          no-title
                          v-on:input="menuDateNaissanceCssConnu = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>

                  <v-row
                    class="mt-0"
                    v-if="erreurValidationAdresseEmail"
                  >
                    <v-col
                      class="pt-1 pb-3 pr-1"
                      cols="12"
                      offset-sm="4"
                      sm="8"
                    >
                      <label style="color: #ff5252">{{
                        $t(
                          "Panier.SectionIdentificationEleve.ErreurValidationEmail"
                        )
                      }}</label>
                    </v-col>
                  </v-row>
                  <!-- SI CEST AUTRE CENTRE DE SERVICES SCOLAIRES -->
                  <v-row
                    class="mt-0"
                    v-if="estCSSExterne"
                  >
                    <v-col
                      cols="12"
                      sm="6"
                      md="4"
                      class="py-1 pr-1"
                    >
                      <v-autocomplete
                        outlined
                        dense
                        hide-details="auto"
                        :items="lstCssJson"
                        :rules="rules.select"
                        return-object
                        :item-text="(item) => item.nom"
                        v-model="informationElevePanierVM.cssFrequente"
                        :label="$t('Panier.SectionIdentificationEleve.CSSFrequente')"
                      >
                      </v-autocomplete>
                    </v-col>

                    <v-col
                      cols="12"
                      sm="6"
                      md="4"
                      class="py-1 pr-1"
                    >
                      <v-autocomplete
                        :label="$t('Panier.SectionIdentificationEleve.EcoleFrequente')"
                        :disabled="informationElevePanierVM.cssFrequente == null"
                        :rules="rules.select"
                        :items="filterEcolePublique"
                        :item-text="(item) => item.nom"
                        return-object
                        v-model="informationElevePanierVM.ecoleFrequente"
                        outlined
                        dense
                        hide-details="auto"
                      >
                      </v-autocomplete>
                    </v-col>

                    <v-col
                      cols="12"
                      sm="6"
                      md="4"
                      class="py-1 pr-1"
                    >
                      <v-text-field
                        :label="$t('Panier.SectionIdentificationEleve.AdresseCourriel')"
                        :rules="[...rules.courriel, ...rules.texte]"
                        v-model="informationElevePanierVM.adresseCourrielCommunication"
                        outlined
                        dense
                        hide-details="auto"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!-- SI C'EST ÉTABLISSEMENT PRIVÉ -->
                  <v-row
                    class="mt-0"
                    v-if="estEtablissementPrive"
                  >
                    <v-col
                      cols="12"
                      sm="6"
                      class="py-1 pr-1"
                    >
                      <v-autocomplete
                        :label="$t('Panier.SectionIdentificationEleve.EtablissementFrequente')"
                        v-model="informationElevePanierVM.etablissementPrive"
                        :rules="rules.select"
                        :items="lstEcolesPriveesJson"
                        :item-text="(item) => item.nom"
                        outlined
                        hide-details="auto"
                        return-object
                        dense
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      class="py-1 pr-1"
                    >
                      <v-text-field
                        :label="$t('Panier.SectionIdentificationEleve.AdresseCourriel')"
                        :rules="[...rules.courriel, ...rules.texte]"
                        v-model="informationElevePanierVM.adresseCourrielCommunication"
                        outlined
                        hide-details="auto"
                        dense
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>

                  <!-- SI EXTERNE => CETTE ROW VA APPARAITRE  -->
                  <v-row
                    v-if="
                      estCSSExterne ||
                      estEtablissementPrive"
                  >
                    <v-col
                      cols="6"
                      md="3"
                      class="py-1 pr-1"
                    >
                      <v-text-field
                        :label="$t('Panier.SectionIdentificationEleve.Nom')"
                        outlined
                        v-model="informationElevePanierVM.nom"
                        :rules="rules.texte"
                        dense
                        hide-details="auto"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="6"
                      md="3"
                      class="py-1 pr-1"
                    >
                      <v-text-field
                        :label="$t('Panier.SectionIdentificationEleve.Prenom')"
                        outlined
                        v-model="informationElevePanierVM.prenom"
                        :rules="rules.texte"
                        dense
                        hide-details="auto"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="6"
                      sm="4"
                      md="2"
                      class="py-1 pr-1"
                    >
                      <v-menu
                        ref="menuNaissanceExterne"
                        v-model="menuDateNaissanceCssExterne"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="informationElevePanierVM.dateNaissance"
                            :label="$t('Panier.SectionIdentificationEleve.DateNaissance')"
                            persistent-hint
                            dense
                            :rules="[...rules.texte, ...rules.dateNaissance]"
                            outlined
                            hide-details="auto"
                            v-mask="'####-##-##'"
                            prepend-icon="mdi-calendar"
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="dateParDefaultExterne"
                          no-title
                          v-on:change="
                            ChangerDateNaissance(
                              typeDateNaissance.eleveExterne,
                              dateParDefaultExterne
                            )
                          "
                          :disabled-date="(date) => date >= new Date()"
                          :min="dateNaissanceMin"
                          :max="dateNaissanceMax"
                          v-on:input="menuDateNaissanceCssExterne = false"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col
                      cols="6"
                      sm="4"
                      md="2"
                      class="py-1 pr-1"
                    >
                      <v-text-field
                        :label="$t('Panier.SectionIdentificationEleve.CodePermanent')"
                        v-mask="'AAAA########'"
                        :rules="[...rules.texte, ...rules.codePermanent]"
                        v-model="informationElevePanierVM.codePermanent"
                        outlined
                        dense
                        hide-details="auto"
                      >
                      </v-text-field>
                    </v-col>

                    <v-col
                      cols="6"
                      sm="4"
                      md="2"
                      class="py-1 pr-1"
                    >
                      <v-select
                        dense
                        v-if="doitDemanderSexeExterne"
                        :items="genreSelect"
                        item-value="valeur"
                        item-text="nom"
                        :rules="rules.select"
                        outlined
                        hide-details="auto"
                        v-model="informationElevePanierVM.sexe"
                        :label="$t('Panier.SectionIdentificationEleve.SexeNaissance')"
                      >
                      </v-select>
                    </v-col>

                  </v-row>

                  <v-row
                    v-if="
                      !(
                        estCSSExterne ||
                        estEtablissementPrive
                      ) && estValideChoixProvenance
                    "
                  >
                    <v-col
                      cols="12"
                      sm="3"
                      order="2"
                      order-sm="1"
                      class="py-1 pr-1"
                    >
                      <v-text-field
                        dense
                        v-if="estValider"
                        v-model="nomEnfantConnu"
                        readonly
                        :label="$t('Panier.SectionIdentificationEleve.Nom')"
                        outlined
                        hide-details="auto"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="3"
                      order="3"
                      order-sm="3"
                      class="py-1 pr-1"
                    >
                      <v-text-field
                        dense
                        readonly
                        v-model="prenomEnfantConnu"
                        v-if="estValider"
                        :label="$t('Panier.SectionIdentificationEleve.Prenom')"
                        outlined
                        hide-details="auto"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="3"
                      order="3"
                      order-sm="3"
                      class="py-1 pr-1"
                    >
                      <v-select
                        dense
                        v-if="doitDemanderSexe && estValider"
                        :items="genreSelect"
                        item-value="valeur"
                        item-text="nom"
                        :rules="rules.select"
                        outlined
                        hide-details="auto"
                        v-model="informationElevePanierVM.sexe"
                        :label="$t('Panier.SectionIdentificationEleve.SexeNaissance')"
                      >
                      </v-select>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="3"
                      order="1"
                      order-sm="4"
                      class="py-1 pr-1"
                      style="text-align: right"
                    >
                      <v-btn
                        :disabled="!PeutValider"
                        :loading="chargementValidation"
                        class="boutonPasserCaisse"
                        v-on:click.stop="Valider()"
                      >{{
                          $t("Panier.SectionIdentificationEleve.Valider")
                        }}</v-btn>
                    </v-col>
                  </v-row>

                  <!-- Courriel contact + confirmation -->
                  <v-row
                    v-if="estValider ||
                      estCSSExterne ||
                      estEtablissementPrive
                    "
                  >
                    <v-col
                      cols="12"
                      sm="6"
                      class="py-1 pr-1"
                    >
                      <v-text-field
                        dense
                        v-model="courrielContact"
                        :label="$t('Panier.SectionIdentificationEleve.CourrielContact')"
                        outlined
                        hide-details="auto"
                        v-on:input="validerCourrielContactConfirmation()"
                        :rules="[...rules.texte, ...rules.courriel]"
                      >
                      </v-text-field>
                    </v-col>

                    <v-col
                      cols="12"
                      sm="6"
                      class="py-1 pr-1"
                    >
                      <v-text-field
                        ref="courrielContactConfirmation"
                        dense
                        v-model="courrielContactConfirmation"
                        :label="$t('Panier.SectionIdentificationEleve.CourrielContactConfirmation')"
                        outlined
                        hide-details="auto"
                        :rules="[...rules.texte, ...rules.courriel, ...rules.courrielContactConfirmation]"
                        onpaste="return false;"
                        autocomplete="null"
                        ondrop="return false;"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>

                  <IdentificationRepondants
                    :value="informationElevePanierVM.repondants"
                    ref="formRepondants"
                    v-if="
                      estCSSExterne ||
                      estEtablissementPrive
                    "
                  />
                  <AdressePrincipale
                    :value="informationElevePanierVM.adressePrincipale"
                    v-if="
                      estCSSExterne ||
                      estEtablissementPrive
                    "
                  />

                  <div v-if="
                      (!estCSSExterne &&
                        !estEtablissementPrive &&
                        estValider) ||
                      estCSSExterne ||
                      estEtablissementPrive
                    ">
                    <DocumentsRequis
                      :documents="documentsPanierAJour"
                      :scolariseMaison="enfantScolariseMaison"
                      v-on:input="mettreAJourDocumentsPanierChildComponent"
                      v-if="panierStore.listeDocumentsPanier.length > 0"
                      class="mt-4"
                    />

                    <!-- Mesures d'aide (Inscrites au plan d'intervention) -->
                    <MesureAide
                      :value="informationElevePanierVM.mesureAides"
                      class="mt-4"
                    />

                    <v-row>
                      <v-col cols="12">
                        <v-checkbox
                          v-model="chkBoxJaiLu"
                          v-on:change="CocherJaiLu()"
                          style="display: inline-block"
                          class="mt-0 py-1"
                        ></v-checkbox>
                        <label style="display: inline-block">{{ $t("Panier.SectionIdentificationEleve.JaiLu") }}
                          <a
                            href="pdf/RegleEtFonctionnementCoursEteEnLigne.pdf"
                            target="_blank"
                          >{{
                              $t(
                                "Panier.SectionIdentificationEleve.PolitiqueCoursEte"
                              )
                            }}</a>
                        </label>
                      </v-col>
                    </v-row>
                  </div>
                </v-form>
                <!--Erreur backend-->
                <v-row v-if="erreurBackEnd != ''">
                  <v-col
                    cols="12"
                    class="text-center"
                  >
                    <v-alert
                      dismissible
                      v-html="erreursAAfficher"
                      type="error"
                      v-if="erreurBackEnd != null"
                    >
                    </v-alert>
                  </v-col>
                </v-row>

                <!--Erreur formulaire incomplet-->
                <div
                  v-if="erreurFormulaireIncomplet"
                  class="v-text-field__details"
                >
                  <div
                    class="v-messages theme--light error--text"
                    role="alert"
                  >
                    <div class="v-messages__wrapper text-end">
                      <div class="v-messages__message message-transition-enter-to">
                        {{ $t("erreurs.formulaire") }}
                      </div>
                    </div>
                  </div>
                </div>

                <!--Erreur cours supprimer du panier-->
                <div
                  v-if="erreurInscriptionCoursSupprimer"
                  class="v-text-field__details"
                >
                  <div
                    class="v-messages theme--light error--text"
                    role="alert"
                  >
                    <div class="v-messages__wrapper text-end">
                      <div
                        class="v-messages__message message-transition-enter-to"
                        v-html="$t('erreurs.erreurInscriptionCoursSupprimer')"
                      >
                      </div>
                    </div>
                  </div>
                </div>

                <!--Erreur inscription-->
                <div
                  v-if="erreurInscription"
                  class="v-text-field__details"
                >
                  <div
                    class="v-messages theme--light error--text"
                    role="alert"
                  >
                    <div class="v-messages__wrapper text-end">
                      <div
                        class="v-messages__message message-transition-enter-to"
                        v-html="erreurInscription"
                      >
                      </div>
                    </div>
                  </div>
                </div>

                <!--Erreur inscription terminé-->
                <div
                  v-if="erreurInscriptionFerme"
                  class="v-text-field__details"
                >
                  <div
                    class="v-messages theme--light error--text"
                    role="alert"
                  >
                    <div class="v-messages__wrapper text-end">
                      <div class="v-messages__message message-transition-enter-to">
                        {{ $t("erreurs.erreurInscriptionFerme") }}
                      </div>
                    </div>
                  </div>
                </div>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              md="4"
              order="1"
              order-md="2"
            >
              <Panier
                ref="panier"
                :estPanierPaiement="false"
              />
            </v-col>
          </v-row>
        </v-col>
        <br />
        <v-row>
          <v-col
            cols="12"
            sm="6"
            class="boutonRevenirSelectionDiv"
          >
            <v-btn
              v-on:click.stop="AllerListeCoursLigne()"
              class="boutonRevenirSelection"
              :disabled="panierStore.chargementPasserCaisse"
            >{{
                $t("Panier.SectionIdentificationEleve.BtnRevenirSelection")
              }}</v-btn>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            class="boutonPasserCaisseDiv"
          >
            <!-- Bouton Passer à la caisse -->
            <v-btn
              :disabled="estDisabledPasserCaisse || !peutSinscrireCours()"
              v-on:click.stop="PasserCaisse()"
              :loading="panierStore.chargementPasserCaisse"
              class="boutonPasserCaisse"
            >
              {{ texteBtnPasserCaisse }}
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-img>
    <BoiteNousJoindre />
    <div class="petiteLigneRouge"></div>
  </div>
</template>

<script>
import EleveInscriptionAjax from '@/services/EleveInscriptionAjax';
import useAppStore from '@/store/appStore';
import useInscriptionStore from '@/store/inscriptionStore';
import usePanierStore from '@/store/panierStore';

import { nextTick } from 'vue';
import BoiteNousJoindre from '../Accueil/BoiteNousJoindre.vue';
import IdentificationRepondants from './IdentificationRepondants.vue';
import AdressePrincipale from './AdressePrincipale.vue';
import DocumentsRequis from './DocumentsRequis.vue';
import MesureAide from './MesureAide.vue';
import Panier from './Panier.vue';
import cssJson from '../../assets/jsonSelectEcole/css.json';
import ecolesPriveesJson from '../../assets/jsonSelectEcole/ecolesPrivees.json';
import ecolesPubliquesJson from '../../assets/jsonSelectEcole/ecolesPubliques.json';
import csqcoutils from '../../outils/CSQCOutils';
import { TypeEleve, InscriptionCSS, TypeDocument } from '../../outils/Enum';

const racineLocalStorage = 'csqc_coursEte';
const localStoragePanier = '_Panier';
const localStorageCssId = '_CSSId';
const selectionRadioButtonLocalStorage = '_selectionInscription';

export default {
  name: 'InfoElevePanierPrincipal',
  components: {
    BoiteNousJoindre,
    IdentificationRepondants,
    AdressePrincipale,
    DocumentsRequis,
    MesureAide,
    Panier,
  },

  setup() {
    const appStore = useAppStore();
    const inscriptionStore = useInscriptionStore();
    const panierStore = usePanierStore();

    return { appStore, inscriptionStore, panierStore };
  },
  data() {
    return {
      selectionInscription: localStorage.getItem(racineLocalStorage + selectionRadioButtonLocalStorage),
      informationEleveInitial: Object,
      dateNaissanceCssConnu: null,
      doitDemanderSexe: false,
      doitDemanderSexeExterne: false,
      genreSelect: [
        {
          nom: this.$t('Panier.SectionIdentificationEleve.Homme'),
          valeur: 'H',
        },
        {
          nom: this.$t('Panier.SectionIdentificationEleve.Femme'),
          valeur: 'F',
        },

      ],
      dateParDefaultExterne: this.obtenirISODate(new Date(2005, 0, 1)),
      dateParDefaultCssConnu: this.obtenirISODate(new Date(2005, 0, 1)),
      lstCssJson: cssJson.sort((a, b) => a.nom.localeCompare(b.nom)),
      lstEcolesPriveesJson: ecolesPriveesJson.sort((a, b) => a.nom.localeCompare(b.nom)),
      dateNaissanceMin: this.obtenirISODate(new Date(1997, 0, 1)),
      dateNaissanceMax: this.obtenirISODate(new Date(2010, 11, 31)),
      lstEcolePubliquesJson: ecolesPubliquesJson.sort((a, b) => a.nom.localeCompare(b.nom)),
      menuDateNaissanceCssConnu: false,
      radioGroup: null,
      CSSMonteregieEstrie: InscriptionCSS.CSSMonteregieEstrie,
      AutreCSS: InscriptionCSS.AutreCSS,
      EtablissementPrive: InscriptionCSS.EtablissementPrive,
      chargementValidation: false,
      erreurBackEnd: null,
      lstCoursDejaAchete: [],
      lstCoursNonEligible: [],
      menuDateNaissanceCssExterne: false,
      enfantScolariseMaison: false,
      estEcoleMonteregieEstrie: false,
      estCSSExterne: false,
      estEtablissementPrive: false,
      erreurValidationAdresseEmail: false,
      estValideChoixProvenance: false,
      organismeFrequenteSelect: null,
      typeDateNaissance: {
        eleveMembre: 1,
        eleveExterne: 2,
      },

      erreurFormulaireIncomplet: false,
      erreurInscription: false,
      erreurInscriptionCoursSupprimer: false,
      erreurInscriptionFerme: false,

      chkBoxJaiLu: false,
      formValid: false,
      nomEnfantConnu: '',
      prenomEnfantConnu: '',
      courrielContact: '',
      courrielContactConfirmation: '',
      documentsRequis: {
        bulletin: null, // A envoyer dans la section DocumentRequis
      },
      documentsPanierChildComponent: null,
      planIntervention: null,
      informationElevePanierVM: {
        organismeSelectionne: null,
        typeEleve: TypeEleve.Inconnu,
        cssId: '',
        nom: '',
        prenom: '',
        cssFrequente: null,
        ecoleFrequente: null,
        etablissementPrive: null,
        adresseCourrielCommunication: '',
        dateNaissance: null,
        panier: [],
        repondants: {
          repondantPere: {
            nom: '',
            prenom: '',
            telephone: '',
            courriel: '',
          },
          repondantMere: {
            nom: '',
            prenom: '',
            telephone: '',
            courriel: '',
          },
          repondantTuteur: {
            nom: '',
            prenom: '',
            telephone: '',
            courriel: '',
          },
        },
        adressePrincipale: {
          numeroMunicipal: '',
          rue: '',
          appartement: '',
          ville: '',
          province: 'QC',
          codePostal: '',
          adresseDe: null,
        },
        mesureAides: {
          planIntervention: null,
          informationComplementaire: '',
          mesureAidesId: '',
        },
      },
      rules: {
        courriel: [
          (v) => !v || /.+@.+\..+/.test(v) || this.$tc('erreurs.CourrielInvalide'),
        ],
        dateNaissance: [
          (v) => !v || /.{10}/.test(v) || this.$t('erreurs.DateNaissanceInvalide'),
        ],
        texte: [
          (val) => (val?.trim() || '').length > 0 || this.$t('erreurs.requis'),
        ],
        codePermanent: [
          (v) => !v ||
            /^[a-zA-Z]{4}\d{8}$/.test(v) ||
            this.$t('erreurs.CodePermanentInvalide'),
        ],
        select: [
          (v) => v != null || this.$t('erreurs.requis'),
        ],
        courrielContactConfirmation: [
          (v) => v === this.courrielContact || this.$t('erreurs.courrielConfirmationDifferent'),
        ],
      },
      estValider: false,
    };
  },
  methods: {
    initialiser() {
      EleveInscriptionAjax.obtenirListeCssMinimise().then((data) => {
        this.inscriptionStore.listeCssMinimise = data;
        this.EstScolariseMaison();
        this.EstMonteregieEstrie();
        this.EstCssExterneSelection();
        this.EstEtablissementPriveSelection();

        this.organismeFrequenteSelect = this.obtenirCssSelectionneLocalStorage;

        if (this.estCSSExterne) {
          this.radioGroup = InscriptionCSS.AutreCSS;
          this.informationElevePanierVM.typeEleve = TypeEleve.AutreCSS;
          this.doitDemanderSexeExterne = true;
          this.estValideChoixProvenance = true;
        } else if (this.estEtablissementPrive) {
          this.radioGroup = InscriptionCSS.EtablissementPrive;
          this.informationElevePanierVM.typeEleve = TypeEleve.EcolePrive;
          this.doitDemanderSexeExterne = true;
          this.estValideChoixProvenance = true;
        } else if (this.estEcoleMonteregieEstrie) {
          this.radioGroup = InscriptionCSS.CSSMonteregieEstrie;
          this.informationElevePanierVM.typeEleve = TypeEleve.Membre;
          this.estValideChoixProvenance = true;
        } else {
          this.estValideChoixProvenance = false;
        }

        this.verifierSiDisponible();
      });

      this.informationEleveInitial = csqcoutils.Cloner(
        this.informationElevePanierVM,
      );
    },

    mettreAJourDocumentsPanierChildComponent(documents) {
      this.documentsPanierChildComponent = documents;
    },
    EstScolariseMaison() {
      const estScolariseMaison = localStorage.getItem(
        `${racineLocalStorage}_scolarisationMaison`,
      );
      if (`${estScolariseMaison}` === 'true') {
        this.enfantScolariseMaison = true;
        this.doitDemanderSexeExterne = true;
      } else {
        this.enfantScolariseMaison = false;
      }
    },
    obtenirBlocOrganismeFiltrer(enumProvenance, estScolariseMaison) {
      const blocOrganismeFiltres = this.inscriptionStore.listeBlocOrganisme.filter((blocOrganisme) => blocOrganisme.organismeId === parseInt(enumProvenance) &&
        (!estScolariseMaison ? true : blocOrganisme.scolariseMaison));
      return blocOrganismeFiltres;
    },
    async verifierSiDisponible() {
      if (this.radioGroup == null) {
        return;
      }
      let cssId = null;

      // Si pendant période examen garder le CSSId sélectionné
      if (this.appStore.modele.optionRegionale.inscriptionExamenOuverte && !this.appStore.modele.optionRegionale.inscriptionExamenTermine) {
        cssId = localStorage.getItem(racineLocalStorage + localStorageCssId);
      }

      if (this.radioGroup === InscriptionCSS.CSSMonteregieEstrie) {
        if (this.organismeFrequenteSelect == null) {
          return;
        }

        cssId = this.organismeFrequenteSelect;
      }

      if (this.radioGroup === InscriptionCSS.CSSMonteregieEstrie) {
        this.informationElevePanierVM.typeEleve = TypeEleve.Membre;
        this.estEcoleMonteregieEstrie = true;
        this.estCSSExterne = false;
        this.estEtablissementPrive = false;
        this.doitDemanderSexe = false;
        this.doitDemanderSexeExterne = false;
      } else if (this.radioGroup === InscriptionCSS.AutreCSS) {
        this.informationElevePanierVM.typeEleve = TypeEleve.AutreCSS;
        this.estEcoleMonteregieEstrie = false;
        this.estCSSExterne = true;
        this.estEtablissementPrive = false;
        this.doitDemanderSexe = false;
        this.doitDemanderSexeExterne = true;
      } else if (this.radioGroup === InscriptionCSS.EtablissementPrive) {
        this.informationElevePanierVM.typeEleve = TypeEleve.EcolePrive;
        this.estEcoleMonteregieEstrie = false;
        this.estCSSExterne = false;
        this.estEtablissementPrive = true;
        this.doitDemanderSexe = false;
        this.doitDemanderSexeExterne = true;
      }

      await this.inscriptionStore.verifierSiDisponible(this.radioGroup, cssId, this.enfantScolariseMaison, true);
      this.erreurInscription = this.inscriptionStore.erreurInscription;

      // Update des prix
      if (this.$refs.panier != null) {
        this.$refs.panier.updateProvenanceEleve();
      }
    },

    async ChangementOrganismeSelectionnee() {
      this.selectionInscription = localStorage.getItem(racineLocalStorage + selectionRadioButtonLocalStorage);

      // refresh des organismes gratuit
      let CSSId = localStorage.getItem(racineLocalStorage + localStorageCssId);
      await this.inscriptionStore.definirOrganismeGratuit(CSSId);

      if (CSSId !== '') {
        if (CSSId === `${null}`) {
          CSSId = -1;
        }
        await this.inscriptionStore.definirMesuresAide(CSSId);
      }

      this.estValideChoixProvenance = true;
      this.verifierSiDisponible();
      this.changerVariable();
    },
    async Valider() {
      this.erreurBackEnd = '';
      this.chargementValidation = true;
      const timestamp = Date.parse(this.dateNaissanceCssConnu);

      if (!Number.isNaN(timestamp) === false) {
        this.erreurBackEnd = this.$t('erreurs.DateNaissanceInvalide');
        this.chargementValidation = false;
        return;
      }

      const validDomains = ['@hotmail', '@gmail', '@yahoo', '@outlook', '@icloud', '@videotron'];
      if (
        validDomains.some((domain) => this.informationElevePanierVM.adresseCourrielCommunication.includes(domain)) &&
        this.informationElevePanierVM.typeEleve === TypeEleve.Membre
      ) {
        this.erreurBackEnd = this.$t('erreurs.courrielFrequentParent');
        this.chargementValidation = false;
        return;
      }

      await EleveInscriptionAjax.validerEleve(
        this.informationElevePanierVM.adresseCourrielCommunication,
        this.dateNaissanceCssConnu,
        this.organismeFrequenteSelect.cssId,
      )
        .then((data) => {
          if (data != null) {
            this.estValider = true;
            this.erreurValidationAdresseEmail = false;
            this.nomEnfantConnu = data.nom;
            this.prenomEnfantConnu = data.prenom;
            this.informationElevePanierVM.dateNaissance =
              this.dateNaissanceCssConnu;
            this.doitDemanderSexe = data.demanderGenre;
          } else {
            this.estValider = false;
            this.erreurValidationAdresseEmail = true;
          }
        })
        .catch((err) => {
          this.erreurBackEnd = err;
        })
        .finally(() => {
          this.chargementValidation = false;
        });
    },
    obtenirISODate(date) {
      return new Date(date).toISOString().substring(0, 10);
    },
    async PasserCaisse() {
      await this.panierStore.rafraichirPanier();

      this.erreurBackEnd = '';
      this.panierStore.chargementPasserCaisse = true;

      if (this.dateNaissanceCssConnu) {
        const timestampCssConnu = Date.parse(this.dateNaissanceCssConnu);

        if (!Number.isNaN(timestampCssConnu) === false) {
          this.erreurBackEnd = this.$t('erreurs.DateNaissanceInvalide');
          this.panierStore.chargementPasserCaisse = false;
          return;
        }
      } else if (this.informationElevePanierVM.dateNaissance) {
        const timestamp = Date.parse(this.informationElevePanierVM.dateNaissance);

        if (!Number.isNaN(timestamp) === false) {
          this.erreurBackEnd = this.$t('erreurs.DateNaissanceInvalide');
          this.panierStore.chargementPasserCaisse = false;
          return;
        }
      }

      await this.declencherValidation();
      await nextTick();

      if (this.erreurValidationAdresseEmail) {
        this.panierStore.chargementPasserCaisse = false;
        return;
      }

      if (!this.formValid) {
        this.erreurFormulaireIncomplet = true;
        this.panierStore.chargementPasserCaisse = false;
        return;
      }
      this.erreurFormulaireIncomplet = false;

      if (this.estExterne) {
        if (
          this.$refs.formRepondants != null &&
          !this.$refs.formRepondants.formValid &&
          this.$refs.formRepondants.erreurMinimumRepondants
        ) {
          this.panierStore.chargementPasserCaisse = false;
          return;
        }
      }

      // Si le panier contient des cours complets
      if (this.coursComplets.length > 0) {
        let coursMessage = '<br /><br />';
        this.coursComplets.forEach((cours) => {
          coursMessage += `<b>&nbsp;&nbsp;–&nbsp;&nbsp;${cours.titre} (${cours.codeMatiere})</b><br />`;
        });
        coursMessage += '<br />';

        // Cours allant dans la liste d'attente (popup de confirmation)
        const message = {
          body: this.$t('Panier.ListeAttenteDialog.CoursSuivants') + coursMessage + this.$t('Panier.ListeAttenteDialog.SiCelaVousConvient'),
        };
        this.$dialog
          .confirm(message, {
            loader: true,
            okText: this.$t('Panier.ListeAttenteDialog.BtnAccepter'),
            cancelText: this.$t('Panier.ListeAttenteDialog.BtnAnnuler'),
          })
          .then(async (dialog) => {
            dialog.close();

            if (this.enfantScolariseMaison && this.formValid && !this.estExterne) {
              this.AfficherDialogueScolariseMaison();
            } else {
              this.AcheterPanier(false);
            }
          }).catch(() => {
            this.panierStore.chargementPasserCaisse = false;
          });
      } else if (this.enfantScolariseMaison && this.formValid && !this.estExterne) {
        this.AfficherDialogueScolariseMaison();
      } else {
        this.AcheterPanier(false);
      }
    },
    AfficherDialogueScolariseMaison() {
      this.informationElevePanierVM.estScolariseMaison = true;
      // Si scolarise a la maison on lui demande s'il est sur de prendre ces cours
      const message = {
        title: this.$t(
          'Panier.SectionIdentificationEleve.AvertissementDialog',
        ),
        body: this.$t(
          'Panier.SectionIdentificationEleve.DialogPasserCaisseScolariseMaison',
        ),
      };
      this.$dialog
        .confirm(message, {
          loader: true,
        })
        .then((dialog) => {
          dialog.close();
          this.AcheterPanier(true);
        }).catch(() => {
          this.AcheterPanier(false);
        });
    },
    async AllerPaiement(eleveEcoleGuid) {
      // Si aucun cours à payer, passer tout de suite à la confirmation
      if (this.coursNonComplets.length === 0) {
        const lienConfirmation = `${this.appStore.modele.urlBase}/#/Paiement/Confirmation/${eleveEcoleGuid}`;

        await EleveInscriptionAjax.demandeFileAttente(
          { lienConfirmation, estPaiement: false, eleveEcoleGuid },
          { panier: this.panierStore.listeCoursPanier, eleveId: this.inscriptionStore.eleveId },
        ).then(() => {
          window.location.href = lienConfirmation;
        }).catch((err) => {
          this.erreurBackEnd = err;
        }).finally(async () => {
          // Retrait des cours dans le panier
          await this.panierStore.definirListeCoursPanier([]);
          const jsonCoursPanier = JSON.stringify([]);
          localStorage.setItem(
            racineLocalStorage + localStoragePanier,
            jsonCoursPanier,
          );
        });
      } else {
        window.location.href = `${this.appStore.modele.urlBase}/#/Paiement`;
      }

      this.panierStore.chargementPasserCaisse = false;
    },
    ChangerDateNaissance(type, dateNaissance) {
      if (type === this.typeDateNaissance.eleveMembre) {
        this.dateNaissanceCssConnu = dateNaissance;
      } else if (type === this.typeDateNaissance.eleveExterne) {
        this.informationElevePanierVM.dateNaissance = dateNaissance;
      }
    },
    async CocherJaiLu() {
      if (this.chkBoxJaiLu === true) {
        await this.declencherValidation();
      }
    },
    async AcheterPanier(scolariseMaisonAccepteDialog) {
      if (this.organismeFrequenteSelect != null) {
        this.informationElevePanierVM.cssId = this.organismeFrequenteSelect.cssId;
      } else if (this.appStore.modele.optionRegionale.inscriptionExamenOuverte && !this.appStore.modele.optionRegionale.inscriptionExamenTermine) {
        // Si pendant période examen garder le CSSId sélectionné
        this.informationElevePanierVM.cssId = localStorage.getItem(racineLocalStorage + localStorageCssId);
      } else {
        this.informationElevePanierVM.cssId = null;
      }

      if (scolariseMaisonAccepteDialog || !this.enfantScolariseMaison) {
        this.informationElevePanierVM.panier = this.panierStore.listeCoursPanier;

        if (this.enfantScolariseMaison && !this.estExterne) {
          this.informationElevePanierVM.typeEleve = TypeEleve.ScolarisationMaison;
        }

        this.planIntervention = this.informationElevePanierVM.mesureAides.planIntervention;
        this.informationElevePanierVM.organismeSelectionne = this.organismeFrequenteSelect;
        this.informationElevePanierVM.courrielContact = this.courrielContact;

        await this.panierStore.acheterPanier(this.informationElevePanierVM);
        if (this.appStore.erreur != null) {
          this.erreurBackEnd = this.appStore.erreur; // TODO retirer lorsque erreur sera entièrement géré par le appStore

          // on a un erreur d'un cours complet terminé
          if (this.appStore.erreur === 'erreurs.CleInscriptionFerme') {
            // Supprimer cours et actualiser panier
            this.panier = await EleveInscriptionAjax.retirerCoursBlocInactif(this.informationElevePanierVM.panier);
            this.panierStore.definirListeCoursPanier(this.panier);

            // Afficher que certain cours ont été retiré du panier
            this.erreurInscriptionCoursSupprimer = true;

            // Si aucun cours restant dans le panier
            if (this.panier.length === 0) {
              this.erreurInscriptionFerme = true;
            }
          } else if (this.appStore.erreur === 'erreurs.CleCoursNonEligibleOrganisme') {
            this.lstCoursNonEligible = await EleveInscriptionAjax.coursNonEligible(this.informationElevePanierVM);
          } else if (this.appStore.erreur === 'erreurs.CleCoursDejaAchete') {
            this.lstCoursDejaAchete = await EleveInscriptionAjax.coursDejaAchete(this.informationElevePanierVM);
          }

          this.panierStore.chargementPasserCaisse = false;
        }

        if (this.panierStore.panier == null) {
          return;
        }

        this.inscriptionStore.eleveId = this.panierStore.panier.id;
        const eleveEcole = this.panierStore.panier.eleveEcoles.find((x) => x.anneeScolaire === this.appStore.modele.anneeEnSeptembre);

        if (this.planIntervention != null) {
          await this.panierStore.envoyerFichier(eleveEcole.id, TypeDocument.PI, this.planIntervention, true);
        }

        this.documentsPanierAJour.forEach(async (d) => {
          if (d.value != null) {
            await this.panierStore.envoyerFichier(eleveEcole.id, d.typeDocument.id, d.value);
          }
        });

        if (this.panierStore.documentPanier.length > 0) {
          Promise.all(this.panierStore.documentPanier).then(() => {
            this.AllerPaiement(eleveEcole.guid);
          }).catch((err) => {
            this.erreurBackEnd = err;
            this.panierStore.chargementPasserCaisse = false;
          });
        } else {
          this.AllerPaiement(eleveEcole.guid);
        }
      }
    },
    async declencherValidation() {
      if (this.$refs.form != null) {
        this.$refs.form.validate();
      }
      if (this.estExterne && this.$refs.formRepondants != null) {
        // sil a rempli des repondants
        this.$refs.formRepondants.validerRepondant();
      }
      if (this.PeutValider) {
        await this.Valider();
      }
    },
    async peutSinscrireCours() {
      await this.verifierSiDisponible();
      if (this.inscriptionStore.erreurInscription != null && this.inscriptionStore.erreurInscription === '') {
        this.erreurInscription = this.inscriptionStore.erreurInscription;
        this.erreurInscriptionFerme = false;
        return false;
      }

      this.erreurInscriptionFerme = true;
      return true;
    },
    changerVariable() {
      this.estValider = false;
      this.erreurFormulaireIncomplet = false;
      this.erreurInscriptionFerme = false;
      this.erreurInscriptionCoursSupprimer = false;
      this.chkBoxJaiLu = false;
      this.erreurBackEnd = '';
    },
    EstEtablissementPriveSelection() {
      const selectionInscription = localStorage.getItem(
        racineLocalStorage + selectionRadioButtonLocalStorage,
      );

      if (selectionInscription === InscriptionCSS.EtablissementPrive) {
        this.estEtablissementPrive = true;
      } else {
        this.estEtablissementPrive = false;
      }
    },
    EstMonteregieEstrie() {
      const selectionInscription = localStorage.getItem(
        racineLocalStorage + selectionRadioButtonLocalStorage,
      );

      if (selectionInscription === InscriptionCSS.CSSMonteregieEstrie) {
        this.estEcoleMonteregieEstrie = true;
      } else {
        this.estEcoleMonteregieEstrie = false;
      }
    },
    EstCssExterneSelection() {
      const selectionInscription = localStorage.getItem(
        racineLocalStorage + selectionRadioButtonLocalStorage,
      );

      if (selectionInscription === InscriptionCSS.AutreCSS) {
        this.estCSSExterne = true;
      } else {
        this.estCSSExterne = false;
      }
    },
    AllerListeCoursLigne() {
      if (
        JSON.stringify(this.informationElevePanierVM) !==
        JSON.stringify(this.informationEleveInitial)
      ) {
        const message = {
          title: this.$t(
            'Panier.SectionIdentificationEleve.AvertissementDialog',
          ),
          body: this.$t(
            'Panier.SectionIdentificationEleve.DialogEffectuerChangement',
          ),
        };
        this.$dialog
          .confirm(message, {
            loader: true,
          })
          .then((dialog) => {
            window.location.href =
              `${this.appStore.modele.urlBase}/#/Boutique`;
            dialog.close();
          });
      } else {
        window.location.href = `${this.appStore.modele.urlBase}/#/Boutique`;
      }
    },

    validerCourrielContactConfirmation() {
      const input = this.$refs.courrielContactConfirmation;
      if (input.value != null && input.value !== '') {
        this.$refs.courrielContactConfirmation.validate();
      }
    },
  },
  computed: {
    documentsPanierSelonOrganisme() {
      return this.panierStore.listeDocumentsPanier.filter((d) => d.coursDocumentOrganismes.some((cdo) => cdo.organismeId === this.radioGroup));
    },
    documentsPanierAJour() {
      const documents = this.documentsPanierSelonOrganisme;
      if (this.documentsPanierChildComponent != null) {
        documents.forEach((d) => {
          const value = this.documentsPanierChildComponent.find((dpcc) => dpcc.id === d.id)?.value;
          if (value != null) d.value = value;
        });
      }
      return documents;
    },
    erreursAAfficher() {
      if (this.erreurBackEnd != null) {
        // L'ajout du toString() corrige l'erreur: this.erreurBackEnd.includes() is undefined (loading infini du bouton)
        if (this.erreurBackEnd.toString().includes('CleDonneeManquanteGrics')) {
          return (
            this.$t('erreurs.CleDonneeManquanteGrics') +
            this.$t(this.erreurBackEnd)
          );
        }
        if (this.erreurBackEnd.toString().includes('CleCoursDejaAchete')) {
          const nomCoursDejaAchete = this.lstCoursDejaAchete.map((cours) => `<b>${cours}</b>`).join(', ');

          return this.$t('erreurs.CleCoursDejaAchete', { cours: nomCoursDejaAchete });
        }
        if (this.erreurBackEnd.toString().includes('CleCoursNonEligibleOrganisme')) {
          const nomCoursNonEligible = this.lstCoursNonEligible.map((cours) => `<b>${cours}</b>`).join(', ');

          return this.$t('erreurs.CleCoursNonEligibleOrganisme', { cours: nomCoursNonEligible });
        }

        let retour = this.$t(this.erreurBackEnd);
        if (
          this.informationElevePanierVM.adresseCourrielCommunication.indexOf(
            'edu.cshc',
          ) > 0
        ) {
          retour +=
            ' Veuillez utiliser le courriel se terminant par @cshc.qc.ca et non pas @edu.cshc.qc.ca';
        }
        return retour;
      } return '';
    },
    estExterne() {
      if (
        this.informationElevePanierVM.typeEleve === TypeEleve.EcolePrive ||
        this.informationElevePanierVM.typeEleve === TypeEleve.AutreCSS
      ) return true;
      return false;
    },
    filterEcolePublique() {
      if (this.estExterne) {
        if (this.informationElevePanierVM.cssFrequente != null) {
          return this.lstEcolePubliquesJson.filter(
            (x) => x.cssId === this.informationElevePanierVM.cssFrequente.id,
          );
        } return [];
      } if (this.organismeFrequenteSelect != null) {
        return this.lstEcolePubliquesJson.filter(
          (x) => x.cssId === this.organismeFrequenteSelect.organisme,
        );
      }
      return [];
    },
    estDisabledPasserCaisse() {
      // Si le courriel contact et confirmation sont vides, le bouton ne s'active pas
      if (this.courrielContact === '' || this.courrielContactConfirmation === '') {
        return true;
      }

      if (
        !this.EstCssExterneSelection &&
        !this.EstEtablissementPriveSelection &&
        !this.estValider &&
        !this.chkBoxJaiLu
      ) {
        return true;
      }

      // S'il n'y a pas de cours dans le panier ou checkbox 'J'ai lu' pas coché, le bouton est désactivé
      if (this.panierStore.listeCoursPanier.length === 0 || !this.chkBoxJaiLu) {
        return true;
      }
      return false;
    },

    PeutValider() {
      return (
        this.organismeFrequenteSelect != null &&
        this.dateNaissanceCssConnu != null &&
        this.dateNaissanceCssConnu !== '' &&
        this.informationElevePanierVM.adresseCourrielCommunication !== '' &&
        /.+@.+\..+/.test(
          this.informationElevePanierVM.adresseCourrielCommunication,
        )
      );
    },
    obtenirCssSelectionneLocalStorage() {
      const cssIdLocalStorage = localStorage.getItem(
        racineLocalStorage + localStorageCssId,
      );
      return this.inscriptionStore.listeCssMinimise.find((x) => x.cssId === cssIdLocalStorage);
    },
    coursNonComplets() {
      return this.panierStore.listeCoursPanier.filter((c) => !c.estListeAttente);
    },
    coursComplets() {
      return this.panierStore.listeCoursPanier.filter((c) => c.estListeAttente);
    },
    texteBtnPasserCaisse() {
      return this.coursComplets.length > 0 && this.coursNonComplets.length === 0 ?
        this.$t('Panier.SectionIdentificationEleve.BtnContinuer') : this.$t('Panier.SectionIdentificationEleve.BtnPasserCaisse');
    },
  },
  created() {
    this.initialiser();
  },
  mounted() {
    this.inscriptionStore.afficherPanier = false;
  },
};
</script>
<style scoped>
.columnBoiteCours {
  padding: 0;
}

.boutonPasserCaisse {
  background-color: #095797 !important;
  border-color: #095797 !important;
  color: white !important;
  height: 40px !important;
}

.boutonRevenirSelection {
  background-color: white !important;
  border: solid 1px #095797 !important;
  color: #095797 !important;
  height: 40px !important;
}

.v-messages__message {
  font-size: 15px;
  line-height: 16px;
}

@media screen and (min-width: 600px) {
  .boutonRevenirSelectionDiv {
    text-align: right;
  }
}

@media screen and (max-width: 599px) {
  .boutonRevenirSelectionDiv {
    text-align: center;
  }

  .boutonPasserCaisseDiv {
    text-align: center;
  }
}
</style>
